export default "__VITE_ASSET__D8nOQ21q__"